const stateLiquidation = (state) => {
  switch (state) {
    case 'W':
      state = 'Reparto';
      break;
    case '4':
      state = 'Liq. documentos';
      break;
    case 'L':
      state = 'Liquidado';
      break;
    case '5':
      state = 'Cerrado';
      break;

    default:
      state = '-';
      break;
  }

  return state;
};

export default stateLiquidation;
